<template>
  <div class="contract-bill-bd">
    <div
      class="bill-map"
      style="height: 200px;"
    >
      <div class="ub">
        <div
          v-show="p11"
          ref="p1"
          class="ub-f1 ub ub-ac"
        ></div>
        <div
          v-show="p22"
          ref="p2"
          class="ub-f1 ub ub-ac"
        ></div>
      </div>
    </div>
    <div class="change-title ub ub-sp">
      <el-radio-group
        v-model="formSearch.type"
        @change="onPageChange({ page: 1 })"
        style="vertical-align: top;"
      >
        <el-radio-button :label="0">{{ $t('Common.com_all') }}</el-radio-button>
        <el-radio-button :label="1">{{ $t('crm_contract_bill.ying_shou') }}</el-radio-button>
        <el-radio-button :label="2">{{ $t('crm_contract_bill.ying_fu') }}</el-radio-button>
      </el-radio-group>
      <custom-date-picker
        v-model="dataTimes"
        type="daterange"
        align="right"
        value-format="YYYY-MM-DD HH:mm:ss"
        style="width: 260px; margin-left: 16px;"
        @change="onChangeDate()"
      ></custom-date-picker>
    </div>
    <div class="table-bd">
      <custom-table
        :data="tableList"
        tableCode="contractBill"
        :slots="['issueNum']"
      >
        <template
          slot="issueNum"
          slot-scope="scope"
        >
          <span>{{ scope.row.issueNum }}/{{ scope.row.periodNum }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    },
    rule: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      formSearch: {
        bizId: '',
        paymentStartDate: undefined,
        paymentEndDate: undefined,
        type: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1
      },
      dataTimes: [],
      p1: {},
      p2: {},
      p11: 0,
      p22: 0,

      tableList: [],
      totalRows: 0,
    };
  },
  // created: function () {
  //   this.Bus.$on('contract_detail', this.getTableList);
  // },
  // destroyed() {
  //   this.Bus.$off('contract_detail', this.getTableList);
  // },
  activated() {
    this.getBillCount();
  },
  mounted: function () {
    const billType = this.getJump('billType');
    this.formSearch.bizId = this.getJump('contractId');
    if (billType) {
      this.formSearch.billType = billType;
    }
    this.getBillCount();
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.ContractDetailBillPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 日期范围
    onChangeDate: function () {
      this.formSearch.paymentStartDate = this.dataTimes && this.dataTimes[0] ? this.dataTimes[0] : undefined;
      this.formSearch.paymentEndDate = this.dataTimes && this.dataTimes[1] ? this.dataTimes[1] : undefined;
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 获取账款统计
    getBillCount: function () {
      this.$getJSON(apis.ContractBillCount, {
        bizId: this.formSearch.bizId,
        billType: this.formSearch.billType,
      }).then((res) => {
        const payable = res.data.payable;
        this.p11 = payable.reduce((pre, item) => pre + (item.amount || 0), 0);
        const data1 = payable.map(t => ({
          item: `${t.tradingState}(${t.periodNum || '-'})`,
          amount: t.amount
        }));
        const receivable = res.data.receivable;
        this.p22 = receivable.reduce((pre, item) => pre + (item.amount || 0), 0);
        const data2 = receivable.map(t => ({
          item: `${t.tradingState}(${t.periodNum || '-'})`,
          amount: t.amount
        }));
        if (this.p1.destroy) {
          this.p1.destroy();
        }
        this.p1 = this.initG2Ring('p1', data1, {
          title: this.$t('crm_contract_bill.ying_fu_zhang_kuan'),
          height: 194,
          subTitle: this.$t('crm_contract_bill.zong_jin_e'),
          totalSize: 15,
          item: 'item',
          value: 'amount'
        });
        if (this.p2.destroy) {
          this.p2.destroy();
        }
        this.p2 = this.initG2Ring('p2', data2, {
          title: this.$t('crm_contract_bill.ying_shou_zhang_kuan'),
          height: 194,
          subTitle: this.$t('crm_contract_bill.zong_jin_e'),
          totalSize: 15,
          item: 'item',
          value: 'amount',
        });
      });
    }
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.contract-bill-bd {
  padding: 0 24px;
  background-color: #ffffff;
  .bill-map {
    border-bottom: 1px solid #f2f3fb;
  }
  .change-title {
    padding: 24px 0 16px;
    h1 {
      color: rgba(0, 0, 0, 0.85);
      line-height: 32px;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .change-list {
    padding: 0 32px;
    background-color: #ffffff;
    .empty {
      line-height: 104px;
      color: rgba(0, 0, 0, 0.25);
      font-size: 16px;
      text-align: center;
    }
    ul li {
      .dit {
        width: 6px;
        height: 6px;
        background: rgba(24, 144, 255, 1);
        border-radius: 3px;
        margin-right: 8px;
      }
      .el-dropdown-link {
        font-size: 14px;
        color: #1890ff;
      }
      border-bottom: 1px solid #e9e9e9;
      padding: 15px;
      .icon-box {
        width: 48px;
        height: 48px;
        line-height: 48px;
        background: rgba(0, 175, 255, 1);
        border-radius: 4px;
        margin-right: 24px;
        text-align: center;
        &.pay {
          background-color: #ff7875;
        }
        .icon {
          color: #ffffff;
          font-size: 28px;
        }
      }
      h1 {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
        font-weight: bold;
        margin-bottom: 4px;
      }
      p {
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
        font-size: 14px;
        &.pay {
          color: #ff7875;
        }
        &:first-child {
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>
